import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import InternationalOdds from './integrationOdds';
import MatchOddsStore from './store';
import Seo from '../../../../components/seo';
import { ScoreUtil } from '../../../../common/utils/scoreUtil';
import { observer } from 'mobx-react';

const MatchOdds = observer(({ sportsType, gameData, detail }) => {
  let { id } = useParams();
  const { getAll, data, loading } = MatchOddsStore();

  useEffect(() => {
    getAll(id);
  }, []);

  return (
    <div className="odds_area">
      <Seo title={`스포츠 ${ScoreUtil.getSportName(sportsType)} 상세 배당`} />
      {/* 국내 해외 비교 */}
      <InternationalOdds data={data} gameData={gameData} />
    </div>
  );
});

export default MatchOdds;
